/* global webpack */

import { last, pick } from 'gleam-shared/helpers/nodash'
import { ref, watch, onMounted, onUnmounted } from 'vue'
import isLeftClick from 'gleam-shared/browser/isLeftClick'

import HELP_CENTER_TYPES from 'help-center/constants/types'

const SLUG_TO_TYPE = {
  docs: HELP_CENTER_TYPES.DOCS,
  guides: HELP_CENTER_TYPES.GUIDES,
  faq: HELP_CENTER_TYPES.FAQS,
  updates: HELP_CENTER_TYPES.UPDATES,
  blog: HELP_CENTER_TYPES.MODERN_BLOG
}

export default function useHelpCenterNavigationInterrupter(sourceFrameRef) {
  const requestedRouteRef = ref(null)

  watch(sourceFrameRef, onSourceFrameChange, { immediate: true })
  onMounted(attachListeners)
  onUnmounted(detachListeners)

  return requestedRouteRef

  function onSourceFrameChange(sourceFrame) {
    requestedRouteRef.value = buildRoute(new URL(sourceFrame.url, webpack.apiServerHost))
  }

  function attachListeners() {
    window.addEventListener('click', onClick)
    window.addEventListener('popstate', onHistoryChange)
  }

  function detachListeners() {
    window.removeEventListener('click', onClick)
    window.removeEventListener('popstate', onHistoryChange)
  }

  function onClick(event) {
    if (!isLeftClick(event) || event.defaultPrevented)  {
      return
    }

    const link = event.target.closest('a')
    if (!link || !isSameSite(link) || !isKnownType(link) || isTargetBlank(link)) {
      return
    }

    event.preventDefault()
    requestedRouteRef.value = buildRoute(link)
  }

  function onHistoryChange({ state }) {
    requestedRouteRef.value = buildRoute(document.location, state, true)
  }

  function isSameSite(link) {
    return requestedRouteRef.value.origin === link.origin
  }

  function isKnownType(link) {
    return !!deriveType(link)
  }

  function isTargetBlank(link) {
    return /\b_blank\b/i.test(link.getAttribute('target'))
  }

  function deriveType(link) {
    const re = /^\/(?:cms_pages\/)?(?:tmp-prefix-)?([^/]+)/
    const slug = last(re.exec(link.pathname))
    return SLUG_TO_TYPE[slug]
  }

  function buildRoute(link, state, popstate) {
    const base = pick(link, 'pathname', 'origin', 'search', 'hash', 'href', 'state')
    const type = deriveType(link)
    return { ...base, type, state, popstate }
  }
}
